/**
 * Aida nella sezione Spedizioni: una configurazione del componente di chat
 * condiviso, non più un componente a sé.
 *
 * Fino al 16-08-2026 questa era l'unica chat «fatta bene» — barra sul bordo,
 * pannello che occupa spazio, casella che cresce — mentre gli altri agenti
 * usavano un pannello in overlay con un'altra veste. Enrico ha scelto **questa**
 * come forma di riferimento per tutti, e il codice è finito in
 * `components/agenti/ChatAgente.tsx`. Qui restano solo l'identità di Aida e i
 * comportamenti che sono suoi: l'apertura da un «?» del tabellone e il rinfresco
 * della pagina dopo un turno che ha usato strumenti.
 */
import { ChatAgente, CHAT_AGENTE_W, type AvvioChat } from "@/components/agenti/ChatAgente";

/** Larghezza del dock aperto. Il guscio M3 la riusa per il padding del contenuto. */
export const AIDA_DOCK_W = CHAT_AGENTE_W;

export type { AvvioChat };

const BASE_PATH = "/api/v1/m3/agente/chat";

const SUGGERIMENTI = [
  "Quali pacchetti ho generato oggi?",
  "Per quali carichi mancano dati?",
  "Quali paesi sono attivi?",
];

export function AidaSidebar({
  open,
  onToggle,
  avvio,
  onAzioneCompletata,
}: {
  open: boolean;
  onToggle: (open: boolean) => void;
  /** Quando presente, la chat si apre con **Aida** che ripete la sua domanda. */
  avvio?: AvvioChat;
  /** Un turno che ha usato strumenti può aver chiuso una domanda: il tabellone
   *  dietro non lo saprebbe, e il badge resterebbe fino al ricaricamento. */
  onAzioneCompletata?: () => void;
}) {
  return (
    <ChatAgente
      aperta={open}
      onApertaChange={onToggle}
      nome="Aida"
      stato="assistente documenti"
      basePath={BASE_PATH}
      modo="inline"
      benvenuto="Ciao! Posso rispondere su documenti, pacchetti e dati dei carichi. Cosa ti serve?"
      suggerimenti={SUGGERIMENTI}
      avvio={avvio}
      onAzioneCompletata={onAzioneCompletata}
    />
  );
}
